<span>
  <button (click)="prev.emit()" [disabled]="isMin()">
    <i class="fa fa-chevron-left" aria-hidden="true"></i>
  </button>
  <button (click)="next.emit()" [disabled]="isMax()">
    <i class="fa fa-chevron-right" aria-hidden="true"></i>
  </button>
</span>
